// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMemberRejectBody = {
  poolId: string;
  targetUserId: string;
};

export type typeMemberRejectOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { targetUserId: string; status: "rejected" };
};

export type typeMemberRejectOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMemberRejectOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMemberRejectOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMemberRejectBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    targetUserId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "targetUserId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMemberReject(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMemberRejectBody);
  }

  return async function postMemberReject(
    payload: typeMemberRejectBody,
  ): Promise<typeMemberRejectOutput200 | typeMemberRejectOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMemberReject" failed before calling the network. #14cd73640e68`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#14cd73640e68" },
        },
        data: null,
      } as typeMemberRejectOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/member/reject`,
      httpMethod: "POST",
      options,
    })) as typeMemberRejectOutput200 | typeMemberRejectOutput400;
  };
}
